import { RouteRecordRaw } from 'vue-router';
import { TrainingMatrixGenerateReportPage } from '@/pages/training';

export const routeName = 'TreinamentosMatrizGerarMatriz';

export const route: RouteRecordRaw = {
  path: 'treinamentos/matriz-treinamentos/gerar-matriz',
  name: routeName,
  component: TrainingMatrixGenerateReportPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Matriz',
    permissions: [{ action: 'readMatrix', subject: 'Training' }],
  },
};
